const VehicleFilterStyle = theme => ({
    firstLabel: { padding: theme.spacing(1, 0, 2, 0) },
    restLabel: { padding: theme.spacing(4, 0, 2, 0) },
});

export default VehicleFilterStyle;
